import { useLiveClock } from '../lib/gameClock';

// Ticking game clock for a ticket leg ("Q4 · 10:58", "HALF", "END Q3", "OT · 2:10").
export const LiveClock = ({ leg, testid }) => {
  const text = useLiveClock(leg.live_period, leg.clock_sec, leg.clock_at, leg.clock_running);
  return <span data-testid={testid || `live-clock-${leg.id}`}>{text.replace(/Quarter/i, 'Q')}</span>;
};

export default LiveClock;
